import { useLocation } from 'react-router';
import { useLayoutEffect } from 'react';

export function useScrollToTop(onPathChange = false) {
    const { pathname } = useLocation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: We want to scroll on navigation to a different path
    useLayoutEffect(() => {
        if (onPathChange) {
            window.scrollTo(0, 0);
        }
    }, [pathname, onPathChange]);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);
}
